module.exports = __webpack_public_path__ + "img/background-video-slider-toyota.2a207b4a.jpg";